import { VideoEditor } from '../components/VideoEditor';

export default function VideoCinematicPage() {
  return <VideoEditor style="cinematic" />;
}
